import { colors, lpColorsDark, lpColorsLight } from './colors';

const baseTheme = {
  space: [0, 4, 8, 16, 24, 36, 48, 64, 128, 256, 512],

  breakpoints: ['320px', '481px', '769px', '1025px'],

  lineHeights: {
    solid: 1,
    input: 1.25,
    copy: 1.5,
    policyTextarea: 2,
  },
  colors,

  lpColorsDark,

  lpColorsLight,

  radii: [0, 2, 4, 6, 8],

  // TODO: This appears not to be supported: https://styled-system.com/theme-specification
  // but cannot delete because it is used as an object directly in `src/component/input.js`
  // and a couple other places
  radius: {
    small: '3px',
    medium: '5px',
    large: '8px',
    larger: '16px',
    biggest: '40px',
  },

  shadows: {
    small: '0px 2px 3px 0px rgba(0, 0, 0, 0.1)',
    medium: '0px 2px 4px 0px rgba(0, 0, 0, 0.2)',
    large: '0px 2px 4px 0px rgba(0, 0, 0, 0.5)',
    smallWhite: '0px 2px 3px 0px rgba(255, 255, 255, 0.1)',
    mediumWhite: '0px 0px 5px 0px rgba(255, 255, 255, 0.2)',
    largeWhite: '0px 0px 5px 0px rgba(255, 255, 255, 0.5)',
  },

  animation: {
    quick: 'all 0.2s',
    normal: 'all 0.3s',
    slow: 'all 0.6s',
  },
  gradients: {
    blue: 'linear-gradient(176deg,#0d0a40,#1e237c)',
    modalHeader: 'linear-gradient(180deg, #191a44 0%, #1b1d5e 100%)',
    backgroundDarkTheme: 'linear-gradient(90deg, #050632 64px, #090C43 50%)',
  },
};

export default baseTheme;
